import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { reservasApi } from '@/data/api/reservasApi';
const KEY = 'reservas';
export function useReservas(filtros) {
    return useQuery({
        queryKey: [KEY, filtros],
        queryFn: () => reservasApi.listar(filtros),
        placeholderData: (previous) => previous,
    });
}
export function useReserva(id) {
    return useQuery({
        queryKey: [KEY, 'detalle', id],
        queryFn: () => reservasApi.ver(id),
        enabled: Boolean(id),
    });
}
export function useInscripciones(reservaId) {
    return useQuery({
        queryKey: [KEY, reservaId, 'inscripciones'],
        queryFn: () => reservasApi.listarInscripciones(reservaId),
        enabled: Boolean(reservaId),
    });
}
export function useCrearReserva() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (v) => reservasApi.crear(v),
        onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
    });
}
export function useConfirmarReserva() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => reservasApi.confirmar(id),
        onSuccess: (r) => {
            qc.invalidateQueries({ queryKey: [KEY] });
            qc.setQueryData([KEY, 'detalle', r.id], r);
        },
    });
}
export function useEditarReserva() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, values }) => reservasApi.editar(id, values),
        onSuccess: (r) => {
            qc.invalidateQueries({ queryKey: [KEY] });
            qc.setQueryData([KEY, 'detalle', r.id], r);
        },
    });
}
export function useAgregarClase(reservaId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (datos) => reservasApi.agregarClase(reservaId, datos),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: [KEY, 'detalle', reservaId] });
            qc.invalidateQueries({ queryKey: [KEY, reservaId, 'inscripciones'] });
            qc.invalidateQueries({ queryKey: [KEY] });
        },
    });
}
export function useCancelarReserva() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, motivo }) => reservasApi.cancelar(id, motivo),
        onSuccess: (r) => {
            qc.invalidateQueries({ queryKey: [KEY] });
            qc.setQueryData([KEY, 'detalle', r.id], r);
        },
    });
}
